// extracted by mini-css-extract-plugin
module.exports = {"coin-item":"style_coin-item__yE5xJ","coin-item__icon":"style_coin-item__icon__xz4sn","coin-item__title":"style_coin-item__title__4IpTM"};